module.exports = __webpack_public_path__ + "static/media/burger-logo.64e69cfd.png";